import { render, staticRenderFns } from "./PlantConfigurationNotificationSubscribersPage.vue?vue&type=template&id=81db5622&"
import script from "./PlantConfigurationNotificationSubscribersPage.vue?vue&type=script&lang=js&"
export * from "./PlantConfigurationNotificationSubscribersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports